import { render } from "./OneVehicleComponent.vue?vue&type=template&id=24885026&scoped=true"
const script = {}

import "./OneVehicleComponent.vue?vue&type=style&index=0&id=24885026&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24885026"]])

export default __exports__